import tagConstants from "constants/Tag";
import { FORM_MODES } from "routes/entity/form/defaults";

export const MODEL_TYPE = "Entity";
export const TAG_MODEL_TYPE = tagConstants.taggableModels.entity;

export const PAGE_TITLES = {
  [FORM_MODES.create]: "Create Entity",
  [FORM_MODES.edit]: "Edit Entity",
};

export const BREADCRUMB_LABELS = {
  [FORM_MODES.create]: "New",
  [FORM_MODES.edit]: "Edit",
};

export const SUCCESS_MESSAGES = {
  [FORM_MODES.create]: "Entity created",
  [FORM_MODES.edit]: "Entity updated",
};
